import React from "react";
import { Helmet } from "react-helmet-async";
import { MdLocationOn } from "react-icons/md";

import styles from "./Address.module.scss";
import { useAddress } from "./useAddress";
import { PageHeader } from "../../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { Button } from "../../../common/components/button/Button";
import { PROFILE_ROUTE } from "../../../common/utils/constants";
import { AddressItem } from "./AddressItem";
import { AddressForm } from "./AddressForm";

export const Address: React.FC = () => {
  const {
    addresses,
    ready,
    adding,
    saving,
    editing,
    initialData,
    isEmpty,
    startAdding,
    startEditing,
    closeForm,
    createAddress,
    updateAddress,
    deleteAddress,
    setDefaultAddress,
  } = useAddress();

  const handleSubmit = editing ? updateAddress : createAddress;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Адреса — ЛОГМОЛЛ</title>
      </Helmet>

      <PageHeader title="Мои адреса" backRoute={PROFILE_ROUTE} />

      {!adding && (
        <div className={styles.AddButton}>
          <Button title="Добавить адрес" onClick={startAdding} variant="primary" />
        </div>
      )}

      {adding && (
        <AddressForm
          initialData={initialData}
          saving={saving}
          isEditing={!!editing}
          onCancel={closeForm}
          onSubmit={handleSubmit}
        />
      )}

      {!ready ? null : isEmpty ? (
        <EmptyState
          icon={MdLocationOn}
          title="Адресов пока нет"
          description="Добавьте адрес доставки, чтобы быстрее оформлять заказы."
        />
      ) : (
        <div className={styles.List}>
          {addresses.map((address) => (
            <AddressItem
              key={address.id}
              address={address}
              onEdit={startEditing}
              onDelete={deleteAddress}
              onSetDefault={setDefaultAddress}
            />
          ))}
        </div>
      )}
    </div>
  );
};